<template>
  <gs1-alert alertClass="info" iconClass="fas fa-spinner fa-pulse color-sky">
    <p>{{ $t('title') }}</p>
  </gs1-alert>
</template>

<script>
import Gs1Alert from './Gs1Alert'
export default {
  name: 'Gs1AlertLoading',
  components: {
    Gs1Alert
  },
  i18n: {
    messages: {
      de: {
        title: 'Suche läuft...'
      },
      en: {
        title: 'Loading…'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/Gs1AlertLoading.vue